import { render } from "./StudentView.vue?vue&type=template&id=26198102"
import script from "./StudentView.vue?vue&type=script&lang=js"
export * from "./StudentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__